import { render, staticRenderFns } from "./technical-details-dialog.vue?vue&type=template&id=26a50c7c&scoped=true&"
import script from "./technical-details-dialog.vue?vue&type=script&lang=js&"
export * from "./technical-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a50c7c",
  null
  
)

export default component.exports